import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import {
  CollaboratorsCard,
  CollaboratorsMenu,
} from '@/features/jobs/details/components/CollaboratorsCard'
import { CollaboratorItemContainer } from '@/features/jobs/details/components/CollaboratorsCard/CollaboratorItem/CollaboratorItemContainer'
import { RequestedProviderContainer } from '@/features/jobs/details/components/CollaboratorsCard/RequestedProvider/RequestedProviderContainer'

export interface CollaboratorsCardContainerProps {
  vm: JobDetailsViewModel
}

export const CollaboratorsCardContainer = observer(
  function CollaboratorsCardContainer({ vm }: CollaboratorsCardContainerProps) {
    return (
      <CollaboratorsCard menu={<CollaboratorsMenuContainer vm={vm} />}>
        <CollaboratorsContainer vm={vm} />
      </CollaboratorsCard>
    )
  },
)

export const CollaboratorsMenuContainer = observer(
  function CollaboratorsMenuContainer({ vm }: CollaboratorsCardContainerProps) {
    if (!vm.collaboratorsVm.canViewCollaboratorActionsMenu) {
      return null
    }
    return (
      <CollaboratorsMenu
        canAddCollaborator={vm.collaboratorsVm.canAddCollaboratorsAsAdmin}
        onAddCollaborator={vm.collaboratorsVm.addCollaboratorsAsAdminVm.show}
        canAddClient={vm.collaboratorsVm.canAddClientsAsNonAdmin}
        onAddClient={vm.collaboratorsVm.addClientsAsTeamMemberVm.show}
        canRatePro={vm.collaboratorsVm.ratingsVm.canRatePro}
        onRatePro={vm.collaboratorsVm.ratingsVm.showRateProDialog}
        canRemoveCollaborator={vm.collaboratorsVm.canRemoveCollaboratorsAsAdmin}
        onRemoveCollaborator={
          vm.collaboratorsVm.removeCollaboratorsAsAdminVm.show
        }
        canRemoveClient={vm.collaboratorsVm.canRemoveClientsAsNonAdminOnly}
        onRemoveClient={vm.collaboratorsVm.removeClientsAsNonAdminVm.show}
      />
    )
  },
)

export const CollaboratorsContainer = observer(function CollaboratorsContainer({
  vm,
}: CollaboratorsCardContainerProps) {
  return (
    <>
      {vm.collaboratorsVm.collaborators.map((collaborator) => (
        <CollaboratorItemContainer
          key={collaborator.member.user.id}
          vm={collaborator}
        />
      ))}

      {vm.collaboratorsVm.showingRequestedProvider && (
        <RequestedProviderContainer provider={vm.job.requestedPro!} vm={vm} />
      )}
    </>
  )
})
